import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { formatDate, constrainedTitle } from "../common/BaseUtil"
import { CONSTRAINED_TITLE_LENGTH_SMALL, CONSTRAINED_TITLE_LENGTH_LARGE } from './CmtyConstant'
import '../../App.css'

export function CmtyBaseTableRow(props) {
    const [maxLength, setMaxLength] = useState(50);

    useEffect(() => {
        const handleResize = () => {
        if (window.innerWidth < 576) {
            setMaxLength(CONSTRAINED_TITLE_LENGTH_SMALL);
        } else if (window.innerWidth < 768) {
            setMaxLength(CONSTRAINED_TITLE_LENGTH_SMALL);
        } else if (window.innerWidth < 992) {
            setMaxLength(CONSTRAINED_TITLE_LENGTH_SMALL);
        } else {
            setMaxLength(CONSTRAINED_TITLE_LENGTH_LARGE);
        }
        };

        handleResize(); // 초기 실행
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    let navigate = useNavigate();
    
    function onClick() {
        let objectId = props.object.id.toString()
        let url = "/cmty_base_post?id=" + objectId;
        navigate(url);
    }

    return (
        <tr key={props.index} style={{fontSize: '14px'}}>
            <td onClick={onClick}>{constrainedTitle(props.object.title, maxLength)} <span style={{ color: "orange" }} hidden={props.object.totalCommentCount==0}>{props.object.totalCommentCount}</span></td>
            <td className="community-table">{props.object.nickname}</td>
            <td className="community-table">{props.object.hits}</td>
            <td className="community-table">{formatDate(props.object.updateAt)}</td>
        </tr>
    );
}